<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-toolbar flat color="white">
      <v-toolbar-title>Bkash Cashout Accepted</v-toolbar-title>
      <!-- <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider> -->
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
        @keyup.enter="paginationMethod"
      ></v-text-field>
      <v-spacer></v-spacer>
      <div v-if="indexData.total > 0">
        <v-btn color="primary" @click="download">
          Export data
          <v-icon light>download</v-icon>
        </v-btn>
        <v-btn color="primary" @click="importData">
          Import data
          <v-icon light>publish</v-icon>
        </v-btn>
      </div>
      <!-- view page start here -->
      <v-dialog v-model="dialog">
        <template>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-container fluid>
                <v-card>
                  <v-card-title class="indigo white--text">
                    <div class="headline">Upload Transaction Docs</div>
                  </v-card-title>
                  <v-card-text>
                    <v-form ref="form" v-model="valid" lazy-validation>
                      <v-layout row>
                        <v-flex xs4>
                          <v-subheader class="black--text font-weight-regular">
                            Name:
                            <b>{{ editedItem.name }}</b>
                          </v-subheader>
                        </v-flex>
                        <v-flex xs4>
                          <v-subheader class="black--text font-weight-regular">
                            Bkash Number:
                            <b>{{ editedItem.account_number }}</b>
                          </v-subheader>
                        </v-flex>
                        <v-flex xs4>
                          <v-subheader class="black--text font-weight-regular">
                            Amount:
                            <b>{{ editedItem.withdraw_amount }}</b>
                          </v-subheader>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs6>
                          <WithdrawImageUpload
                            @change="onImageChange($event)"
                            select-text="Select Image"
                          />
                        </v-flex>
                        <v-flex xs6 class="ml-5">
                          <v-layout row>
                            <v-text-field
                              v-model="transDocs.transaction_id"
                              :rules="inputRules"
                              label="Transaction ID"
                              outline
                            ></v-text-field>
                          </v-layout>
                          <v-layout row>
                            <!-- <v-text-field
                            v-model="transDocs.transaction_date" 
                            :rules="inputRules"
                            label="Transaction Date" 
                            outline
                            ></v-text-field> -->
                            <v-menu
                              ref="menu"
                              v-model="menu"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="transDocs.transaction_date"
                                  :rules="inputRules"
                                  label="Transaction Date"
                                  readonly
                                  outline
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                ref="picker"
                                v-model="transDocs.transaction_date"
                                :max="new Date().toISOString().substr(0, 10)"
                                @change="save(date)"
                              ></v-date-picker>
                            </v-menu>
                          </v-layout>
                          <v-layout row>
                            <!-- <v-text-field
                            v-model="transDocs.transaction_time"
                            :rules="inputRules"
                            label="Transaction Time" 
                            outline
                            ></v-text-field> -->
                            <v-menu
                              ref="menu"
                              v-model="menu2"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              :return-value.sync="time"
                              lazy
                              transition="scale-transition"
                              offset-y
                              full-width
                              max-width="290px"
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="transDocs.transaction_time"
                                  :rules="inputRules"
                                  label="Transaction Time"
                                  readonly
                                  outline
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-time-picker
                                v-if="menu2"
                                v-model="transDocs.transaction_time"
                                full-width
                                @click:minute="$refs.menu.save(time)"
                              ></v-time-picker>
                            </v-menu>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-form>
                  </v-card-text>
                </v-card>
                <v-list-tile-title class="font-weight-bold text-sm-center">
                  Rejection Comments
                </v-list-tile-title>
                <v-layout row justify-space-around>
                  <v-flex xs12>
                    <v-card>
                      <v-card-text class="px-1">
                        <v-textarea
                          v-model="commentData.comment"
                          label="Comment here, why are you rejecting this request?"
                          box
                          required
                        ></v-textarea>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
          <!-- <v-divider inset></v-divider> -->
          <v-container fluid>
            <v-layout row>
              <div>
                <v-btn color="success" @click="disbursedItem(editedItem.id)">
                  Disburse
                </v-btn>
                <v-btn color="warning" @click="rejectItem(editedItem.id)">
                  Reject
                </v-btn>
                <v-btn color="red" @click="close">Close</v-btn>
                <!-- <v-btn color="warning" @click="backToPending(editedItem)">Back-to-Pending</v-btn> -->
              </div>
            </v-layout>
          </v-container>
        </template>
      </v-dialog>
      <!-- view page end here -->
    </v-toolbar>
    <div v-if="isLoaded">
      <div v-if="alertMsg">
        <v-alert
          v-if="error == 0 && statusCode == 200"
          :value="true"
          type="success"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && statusCode == 204"
          :value="true"
          type="info"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && (statusCode == 403 || statusCode == 400)"
          :value="true"
          type="warning"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && statusCode == 500"
          :value="true"
          type="error"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
      </div>
      <div v-if="indexData.dataset2.total < 1" class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-data-table
        :headers="headers"
        :items="indexData.dataset2.data"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="elevation-1"
      >
        <v-progress-linear color="blue" indeterminate></v-progress-linear>
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ props.header.text }}
              </span>
            </template>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>

        <template v-if="indexData.dataset2.total > 0" v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.user_id }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.withdraw_amount }}</td>
          <td>{{ props.item.account_number }}</td>
          <td>{{ props.item.wallet_account_name }}</td>
          <td>{{ props.item.message }}</td>
          <td>{{ props.item.accepted_by }}</td>
          <td>{{ props.item.accepted_at }}</td>
          <td class="justify-center layout px-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="checkItem(props.item)"
                >
                  visibility
                </v-icon>
              </template>
              <span>view</span>
            </v-tooltip>
          </td>
        </template>
        <template v-else v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">
            {{ errorMsg }}
          </v-alert>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <template v-slot:pageText>
          Rows {{ indexData.dataset2.from }} - {{ indexData.dataset2.to }} of
          {{ indexData.dataset2.total }}
        </template>
      </v-data-table>
      <template>
        <div class="text-xs-center">
          <v-layout wrap>
            <v-flex xs10 sm10 md10>
              <v-pagination
                right
                v-model="indexData.dataset2.current_page"
                :length="indexData.dataset2.last_page"
                @input="onPageChange"
              ></v-pagination>
            </v-flex>
          </v-layout>
        </div>
      </template>
    </div>
    <v-layout>
      <XLFileUpload
        v-if="openUploadDialod == 1"
        @change="changeOpenDialog($event)"
      ></XLFileUpload>
    </v-layout>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { WithdrawImageUpload } from "@/components/index";
  import XLFileUpload from "@/components/XlsImport/BkashCashoutImport";
  import axios from "axios";
  import api from "./../../api/connectingUrls";
  import { saveAs } from "file-saver";

  export default {
    components: {
      WithdrawImageUpload,
      XLFileUpload,
    },
    data: () => ({
      dialog: false,
      alertMsg: false,
      menu: false,
      menu2: false,
      time: null,
      date: null,
      apiUrl: "withdraw-status-list",
      openUploadDialod: 0,
      sl: 1,
      headers: [
        { text: "ID", align: "left", value: "id" },
        { text: "Dasher ID", align: "left", value: "user_id" },
        { text: "Dasher Name", value: "name" },
        { text: "Withdraw Amount", align: "left", value: "withdraw_amount" },
        { text: "Bkash Number", value: "account_number" },
        { text: "Account Holder", value: "wallet_account_name" },
        { text: "Message", value: "message" },
        { text: "Accepted By", value: "accepted_by" },
        { text: "Accepted At", value: "accepted_at" },
        { text: "Actions", align: "center", value: "name", sortable: false },
      ],
      loading: false,
      search: "",
      pagination: {
        rowsPerPage: 10,
      },
      rowsPerPageItems: [10, 20, 50, 100, 200, 500],
      editedIndex: -1,
      transDocs: {
        transaction_id: "",
        transaction_date: "",
        transaction_time: "",
        trans_image: null,
      },
      editedItem: {},
      defaultItem: {
        rowsPerPage: 10,
      },
      commentData: {
        id: null,
        comment: null,
      },
      valid: true,
      inputRules: [(v) => !!v || "This field is required"],
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
      isLoaded() {
        if (this.indexData.dataset2) {
          return true;
        } else {
          return false;
        }
      },
    },

    watch: {
      pagination() {
        this.onPageChange();
      },
      menu(val) {
        val && setTimeout(() => (this.$refs.picker.activePicker = "DATE"));
      },
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.reloading();
    },

    methods: {
      reloading() {
        this.$store.dispatch("changeWithdrawStatus", [
          this.apiUrl,
          2,
          "",
          1,
          this.pagination.rowsPerPage,
        ]);
      },
      initialize() {
        this.paginationMethod();
      },

      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },

      onImageChange(file) {
        var reader = new FileReader();
        reader.addEventListener(
          "load",
          function () {
            // convert image file to base64 string
            let str = reader.result;
            let res = str.split(",");
            this.transDocs.trans_image = res[1];
          }.bind(this),
          false
        );

        if (file) {
          reader.readAsDataURL(file);
        }
      },

      save(date) {
        this.$refs.menu.save(date);
        this.menu = false;
      },

      checkItem(item) {
        // console.log(item)
        this.editedIndex = this.indexData.dataset2.data.indexOf(item);
        this.editedItem = Object.assign([], item);
        this.dialog = true;
      },

      rejectItem(itemId) {
        this.commentData.id = itemId;
        if (this.commentData.comment != null) {
          var popUpMsg = confirm("Are you sure want to reject this request?");
          if (popUpMsg) {
            this.$store.dispatch("updateRequest", [
              "withdraw-reject",
              this.commentData,
            ]);
          }
          this.reloading();
          this.close();
        } else {
          alert("Please write a rejecting comment!");
        }
      },
      async download() {
        const token = window.localStorage.getItem("datadash_token");
        var fileName = "Bkash-Accepted-report" + new Date().toLocaleString();
        if (token != null) {
          await axios
            .get(`${api.rootUrl}/${"withdraw-export"}/${2}`, {
              file_name: fileName,
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              responseType: "blob",
            })
            .then((response) => {
              saveAs(response.data, fileName);
            });
        }
      },
      changeOpenDialog() {
        this.openUploadDialod = 0;
      },
      importData() {
        if (this.openUploadDialod == 1) {
          this.openUploadDialod = 0;
        } else {
          this.openUploadDialod = 1;
        }
      },

      disbursedItem(itemId) {
        // console.log(this.transDocs)
        if (this.$refs.form.validate()) {
          // // const index = this.indexData.indexOf(item)
          var popUpMsg = confirm(
            "Are you sure want to disbursed this request?"
          );
          if (popUpMsg) {
            this.$store.dispatch("disbursedAmount", [
              itemId,
              this.transDocs,
              "withdraw-disbursed",
            ]);
          }
          this.reloading();
          this.close();
        }
      },

      backToPending(item) {
        // console.log(item)
        // // const index = this.indexData.indexOf(item)
        var popUpMsg = confirm(
          "Are you sure want to back to pending this request?"
        );
        if (popUpMsg) {
          this.$store.dispatch("changeWithdrawStatus", [
            "withdraw-disbursed",
            item.id,
            "",
            1,
            this.pagination.rowsPerPage,
          ]);
          // this.$store.dispatch('changeStatus',[ item.id, 'withdraw-disbursed'])
        }
        this.reloading();
        this.close();
      },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.transDocs = Object.assign({}, null);
          this.editedIndex = -1;
        }, 300);
      },

      onPageChange() {
        this.paginationMethod();
      },

      paginationMethod() {
        // console.log(this.search)
        this.loading = true;

        if (this.search) {
          this.pagination.rowsPerPage = 1000;
          this.$store.dispatch("changeWithdrawStatus", [
            this.apiUrl,
            2,
            this.search,
            this.indexData.dataset2.current_page,
            this.pagination.rowsPerPage,
          ]);
          this.loading = this.indexData.dataset2 ? false : true;
        } else {
          if (this.pagination.rowsPerPage == 1000) {
            this.pagination.rowsPerPage = 10;
          }
          this.$store.dispatch("changeWithdrawStatus", [
            this.apiUrl,
            2,
            "",
            this.indexData.dataset2.current_page,
            this.pagination.rowsPerPage,
          ]);
          this.loading = !this.indexData.error ? false : true;
        }
        this.dialog = false;
      },
    },
  };
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem

  .imageResize
    width: auto
    height: auto
</style>
